import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material";
import JSONPretty from 'react-json-pretty';
import { useDetailConfigLocal } from '../hooks/detailConfigLocal.hook';

const dataProviderName = 'administrations/revenueruleset';
const model = 'administrations/revenueruleset';
const modelExposedName = 'Revenue Ruleset';
const wizardAction = 'create';

const Create = (params) => {

    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(false);
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { loadOne:loadOneDeal } = useDataProvider('administrations/revenuedeal');
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const { detailConfig } = existingModules[dataProviderName];
    const { detailConfigLocal } = useDetailConfigLocal(detailConfig, {...item, data: {...item?.data, revenueDeal: discover('revenueDeal')}});

    useEffect(() => {
        loadOne(null).then(e => setDrawable(true));
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    // console.info('CARICO IL DEAL', discover('deal._id'));
                    // await loadOneDeal(discover('deal._id'));
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <>
             {/* <JSONPretty data={discover('revenueDeal')} className="json-wrapper" /> */}
                <DetailComponent
                    disableDetailConfigOverride={true}
                    values={{
                        ...item?.data,
                        revenueDeal: discover('revenueDeal'),
                        revenueDeal_id: discover('revenueDeal._id')
                    }}
                    modelName={model.split('/')[1]}
                    detailConfig={detailConfigLocal}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    title={t('New {{itemname}}', { itemname: t(modelExposedName) })}
                    canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
                    header={
                        <InfoHeader
                            view="wizard"
                            title={t('Create new {{itemname}}', { itemname: t(modelExposedName) })}
                            subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                        />
                    }
                    {...params}
                />
            </>
    )
}

export default Create;